<template>
    <table class="table bg-white table-bordered">
        <tbody v-if="this.response.method !== 'Structural Similarity Index Measure'">
            <tr>
                <td>
                    {{ translate('All') }}
                </td>
                <td>
                    {{ this.factors.all }} <span v-if="this.response.method === 'Absolute Error Count'">{{ translate('Pixels') }}</span>
                </td>
            </tr>
            <tr>
                <td>
                    {{ translate('Blue') }}
                </td>
                <td>
                    {{ this.factors.blue }} <span v-if="this.response.method === 'Absolute Error Count'">{{ translate('Pixels') }}</span>
                </td>
            </tr>
            <tr>
                <td>
                    {{ translate('Green') }}
                </td>
                <td>
                    {{ this.factors.green }} <span v-if="this.response.method == 'Absolute Error Count'">{{ translate('Pixels') }}</span>
                </td>
            </tr>
            <tr>
                <td>
                    {{ translate('Red') }}
                </td>
                <td>
                    {{ this.factors.red }} <span v-if="this.response.method == 'Absolute Error Count'">{{ translate('Pixels') }}</span>
                </td>
            </tr>
        </tbody>
    </table>
</template>
<script>
import { translate } from '../../../../../../../helper/translate';
export default {
    name: 'ImageQualityFactorTable',
    props: {
        factors: Object,
        response: Object,
        percentDiff: String,
    },
};
</script>
<style></style>
